// Taken line for line from pst-viewer repo
// Then added extra stuff for mime encoding

import * as DOMPurify from 'dompurify';

const uriKeepRegexp = /^(?:mailto|tel|callto|cid|data):/i;

// Specify proxy URL
// const proxy = 'https://my.proxy/?url=';

// What do we allow? Not much for now. But it's tight.
const config = {
	WHOLE_DOCUMENT: false,
	ALLOW_UNKNOWN_PROTOCOLS: true,
};

// Specify attributes to proxy
const attributes = ['action', 'background', 'href', 'poster', 'src'];

// specify the regex to detect external content
// const regex = /(url\("?)(?!data:)/gim;

/**
 *  Take CSS property-value pairs and proxy URLs in values,
 *  then add the styles to an array of property-value pairs
 */
/*
const addStyles = (output: string[], styles: CSSStyleDeclaration) => {
    for (let prop = styles.length - 1; prop >= 0; prop--) {
        const name = styles[prop] as any;
        if (styles[name]) {
            const url = styles[name].replace(regex, '$1' + proxy);
            styles[name] = url;
        }
        if (styles[name]) {
            output.push(styles[prop] + ':' + styles[name] + ';');
        }
    }
};
*/

/**
 * Take CSS rules and analyze them, proxy URLs via addStyles(),
 * then create matching CSS text for later application to the DOM
 */
/*
const addCSSRules = (output: string[], cssRules: CSSRuleList) => {
    for (let index = cssRules.length - 1; index >= 0; index--) {
        const rule = cssRules[index] as any;

        // check for rules with selector
        if (rule.type === 1 && rule.selectorText) {
            output.push(rule.selectorText + '{');
            if (rule.style) {
                addStyles(output, rule.style);
            }
            output.push('}');
            // check for @media rules
        } else if (rule.type === rule.MEDIA_RULE) {
            output.push('@media ' + rule.media.mediaText + '{');
            addCSSRules(output, rule.cssRules);
            output.push('}');
            // check for @font-face rules
        } else if (rule.type === rule.FONT_FACE_RULE) {
            output.push('@font-face {');
            if (rule.style) {
                addStyles(output, rule.style);
            }
            output.push('}');
            // check for @keyframes rules
        } else if (rule.type === rule.KEYFRAMES_RULE) {
            output.push('@keyframes ' + rule.name + '{');
            for (let i = rule.cssRules.length - 1; i >= 0; i--) {
                const frame = rule.cssRules[i];
                if (frame.type === 8 && frame.keyText) {
                    output.push(frame.keyText + '{');
                    if (frame.style) {
                        addStyles(output, frame.style);
                    }
                    output.push('}');
                }
            }
            output.push('}');
        }
    }
};
*/

/**
 * Proxy a URL in case it's not a Data URI
 */
/*
const proxyAttribute = (url: string) => {
    if (/^data:image\//.test(url)) {
        return url;
    } else {
        return proxy;
    }
};
*/

// Add a hook to enforce proxy for leaky CSS rules
/*
DOMPurify.addHook('uponSanitizeElement', (node, data) => {
    if (data.tagName === 'style') {
        const output: string[] = [];
        const sheet = (node as any).sheet as CSSStyleSheet;
        addCSSRules(output, sheet.cssRules);
        node.textContent = output.join('\n');
    }
});
*/

// Add a hook to enforce proxy for all HTTP leaks incl. inline CSS
DOMPurify.addHook('afterSanitizeAttributes', node => {
	// Check all src attributes and proxy them
	for (let i = 0; i <= attributes.length - 1; i++) {
		const key = attributes[i];
		if (node.hasAttribute(key)) {
			const attr = node.getAttribute(key) || '';
			if (!uriKeepRegexp.test(attr)) {
				node.removeAttribute(key);
			}
		}
	}

	// Check all style attribute values and proxy them
	/*
    if (node.hasAttribute('style')) {
        const node2 = node as HTMLElement;
        const styles = node2.style;
        const output = [];
        for (let prop = styles.length - 1; prop >= 0; prop--) {
            const name = styles[prop] as any;

            // we re-write each property-value pair to remove invalid CSS
            if (node2.style[name] && regex.test(node2.style[name])) {
                const url = node2.style[name].replace(regex, '$1' + proxy);
                node2.style[name] = url;
            }
            output.push(styles[prop] + ':' + node2.style[name] + ';');
        }
        // re-add styles in case any are left
        if (output.length) {
            node2.setAttribute('style', output.join(""));
        } else {
            node2.removeAttribute('style');
        }
    }
    */
});

// Clean HTML string and write into our DIV
export const cleanHtml = (dirty: string) => {
    // const unwrapped = dirty.replaceAll('=\r\n', '');
    return DOMPurify.sanitize(dirty, config);
};
export default cleanHtml;
